import { cn } from '@/lib/utils';

interface StepIndicatorProps {
  current: number;
  total: number;
}

export default function StepIndicator({ current, total }: StepIndicatorProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-1.5">
        {Array.from({ length: total }).map((_, i) => (
          <div
            key={i}
            className={cn(
              'h-1.5 flex-1 rounded-full',
              i < current ? 'bg-primary' : 'bg-gray-200 dark:bg-gray-700'
            )}
          />
        ))}
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400">Paso {current} de {total}</p>
    </div>
  );
}
